import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isShowLoader: false,
  isShowHomePageLoader: false,
};

const translationSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    setIsShowLoader(state, action) {
      state.isShowLoader = action.payload;
    },
    setIsShowHomePageLoader(state, action) {
      state.isShowHomePageLoader = action.payload;
    },
  },
});

export const { setIsShowLoader, setIsShowHomePageLoader } = translationSlice.actions;
const loaderReducer = translationSlice.reducer;

export default loaderReducer;
